// @flow

import { dashboardUrl } from "@cabonline/shared/utils/env"

export default {
  id: "admin",
  intlBase: "externalApps.admin",
  url: (dashboardUrl("admin"): any),
  localUrl: `${window.location.origin}/dashboard`
}
